<template>
  <b-modal
    id="'salvarArquivo'"
    :ref="'salvarArquivo'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:justify;"
          >
            <h4>
              Escolha o arquivo que você deseja enviar!
            </h4>
            <p
              class="text-secondary"
              style="font-size:small"
            />
          </b-col>
          <div
            class="mt-1 px-1"
            style="flex-grow:1"
          >
            <b-row>
              <b-col cols="12">
                <carregar-arquivo
                  ref="upload"
                  v-model="arquivo"
                />
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col cols="12">
                <b-form-group label="Adicione uma observação sobre este documento">
                  <b-textarea
                    v-model="observacao"
                    placeholder="Observação (opcional)"
                    rows="3"
                    max-rows="6"
                  />
                </b-form-group>
              </b-col>
            </b-row> -->
            <b-row class="mt-1">
              <b-col cols="6">
                <b-btn
                  variant="danger"
                  class="w-100"
                  @click="cancelar()"
                >Cancelar</b-btn>
              </b-col>
              <b-col cols="6">
                <b-btn
                  variant="success"
                  class="w-100"
                  @click="fechar()"
                >Publicar</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'UploadProcedimentos',
  components: {
    CarregarArquivo: () => import('@/shared/components/carregar-arquivo/CarregarArquivo.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      arquivo: null,
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.salvarArquivo.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.salvarArquivo.hide()
      this.$emit('cancelar')
    },
    fechar() {
      this.$refs.salvarArquivo.hide()
      // const formData = this.$refs.upload.getFormDataBody()
      const file = this.$refs.upload.getFile()
      this.$emit('hidden', file)
    },
    getFormDataBody(file, body) {
      const formData = new window.FormData()
      if (file) {
        formData.append('file', file.file, file.filename || file.name)
      }
      formData.append('body', JSON.stringify(body))

      return formData
    },
  },
}
</script>
